import { useState } from 'react';

import { usePlatform } from '@/platform/usePlatform';

/**
 * Просьба разрешить боту писать человеку.
 *
 * Без этого права уведомление получает отказ платформы и канал
 * отключается — человек молча остаётся без «портрет готов». Показывается
 * только там, где платформа умеет спрашивать, и пока право не выдано.
 * Отказ не выдаётся за согласие: обещать «сообщим» без права писать
 * нельзя.
 */
type Status = 'idle' | 'pending' | 'granted' | 'denied';

export function MessageAccessPrompt() {
  const platform = usePlatform();
  const [status, setStatus] = useState<Status>('idle');

  if (status === 'granted') {
    return (
      <p className="rounded-card border border-border bg-surface px-3 py-2 text-xs text-text-2">
        Готово: сообщим, когда портрет или фотосессия будут готовы.
      </p>
    );
  }

  if (platform.getMessageAccess() !== 'not_granted') {
    return null;
  }

  const ask = async () => {
    setStatus('pending');
    setStatus((await platform.requestMessageAccess()) ? 'granted' : 'denied');
  };

  return (
    <div className="flex flex-col gap-2 rounded-card border border-border bg-surface px-3 py-3">
      <p className="text-sm text-text">Сообщать, когда всё готово</p>
      <p className="text-xs text-text-2">
        Разрешите боту писать вам — пришлём сообщение, когда портрет или фотосессия будут готовы.
      </p>

      {status === 'denied' && (
        <p className="text-xs text-danger">
          Разрешение не выдано, поэтому сообщения не придут. Передумаете — нажмите кнопку ещё раз.
        </p>
      )}

      <button
        type="button"
        onClick={() => void ask()}
        disabled={status === 'pending'}
        className="btn btn-secondary self-start px-4 py-2 text-sm"
      >
        Разрешить сообщения
      </button>
    </div>
  );
}
